export default "__VITE_ASSET__CT_5OtBp__"